<template>
  <div id="app">
    <div class="auth-wrapper">
      <div class="auth-inner">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
// dark.css vira um arquivo à parte no build e só é carregado com o tema escuro ligado
import darkCssUrl from '!!file-loader?name=css/[name].[contenthash:8].[ext]!@/assets/css/dark.css';

const DARK_CSS_ID = 'theme-dark-css';

export default {
  name: 'App',
  computed: {
    ...mapState({darkTheme: 'darkTheme'}),
    // Escuro só nas telas do sistema (layout App, onde fica o botão). Painel do signatário e telas
    // públicas ficam sempre no claro
    useDark() {
      return this.darkTheme === 'ativo' && this.$route.matched.some(record => record.name === 'App');
    },
  },
  watch: {
    useDark: {
      immediate: true,
      handler(value) {
        if (value) this.enableDark();
        else this.disableDark();
      },
    },
  },
  methods: {
    enableDark() {
      if (!document.getElementById(DARK_CSS_ID)) {
        const link = document.createElement('link');
        link.id = DARK_CSS_ID;
        link.rel = 'stylesheet';
        link.href = darkCssUrl;
        document.head.appendChild(link);
      }
      document.documentElement.classList.add('dark-theme');
    },
    disableDark() {
      document.getElementById(DARK_CSS_ID)?.remove();
      document.documentElement.classList.remove('dark-theme');
    },
  },
}

import(/* webpackChunkName: "moment" */'moment/moment');
import(/* webpackChunkName: "Theme" */ './assets/js/theme.js');
import(/* webpackChunkName: "jquery" */'jquery/dist/jquery.min');
import(/* webpackChunkName: "daterangeicker" */'daterangepicker');
import(/* webpackChunkName: "BootStrapBundle" */'bootstrap/dist/js/bootstrap.bundle.min');
</script>

<style lang="css" scoped>
@import "~bootstrap/dist/css/bootstrap.min.css";
@import "assets/fonts/style.css";
@import "assets/css/main.css";
@import '~@fortawesome/fontawesome-free/css/all.css';
@import "assets/css/prism/prism.css";
</style>

<style lang="scss">

.required:after {
  content:" *";
  color: red;
}
</style>
